// Import all case images
import guta1 from '../assets/images/cases/guta-perka-1.jpg';
import guta2 from '../assets/images/cases/guta-perka-2.jpg';
import guta3 from '../assets/images/cases/guta-perka-3.jpg';
import guta4 from '../assets/images/cases/guta-perka-4.jpg';
import guta5 from '../assets/images/cases/guta-perka-5.jpg';
import guta7 from '../assets/images/cases/guta-perka-7.jpg';
import guta8 from '../assets/images/cases/guta-perka-8.jpg';
import gutaCase1Middle from '../assets/images/cases/guta-perka-middle-case1.jpg';
import gutaCase3Middle from '../assets/images/cases/guta-perka-case3-middle.jpg';
import itumCase1_1 from '../assets/images/cases/itum-nekev-case1-1.jpg';
import itumCase1_2 from '../assets/images/cases/itum-nekev-case1-2.jpg';
import itumCase1_3 from '../assets/images/cases/itum-nekev-case1-3.jpg';
import itumCase2_1 from '../assets/images/cases/itum-nekev-case2-1.jpg';
import itumCase2_2 from '../assets/images/cases/itum-nekev-case2-2.jpg';

import havharatCase1_1 from '../assets/images/cases/havharat-case1-1.jpg';
import havharatCase1_2 from '../assets/images/cases/havharat-case1-2.jpg';
import havharatCase2_1 from '../assets/images/cases/havharat-case2-1.jpg';
import havharatCase2_2 from '../assets/images/cases/havharat-case2-2.jpg';

import machshirCase1_1 from '../assets/images/cases/machshir-case1-1.jpg';
import machshirCase1_2 from '../assets/images/cases/machshir-case1-2.jpg';
import machshirCase1_3 from '../assets/images/cases/machshir-case1-3.jpg';
import machshirCase2_1 from '../assets/images/cases/machshir-case2-1.jpg';
import machshirCase2_2 from '../assets/images/cases/machshir-case2-2.jpg';
import machshirCase3_1 from '../assets/images/cases/machshir-case3-1.jpg';
import machshirCase3_2 from '../assets/images/cases/machshir-case3-2.jpg';
import machshirCase3_3 from '../assets/images/cases/machshir-case3-3.jpg';
import machshirCase4_1 from '../assets/images/cases/machshir-case4-1.jpg';
import machshirCase4_2 from '../assets/images/cases/machshir-case4-2.jpg';
import machshirCase4_3 from '../assets/images/cases/machshir-case4-3.jpg';
import machshirCase4_4 from '../assets/images/cases/machshir-case4-4.jpg';
import machshirCase4_5 from '../assets/images/cases/machshir-case4-5.jpg';
import machshirCase5_1 from '../assets/images/cases/machshir-case5-1.jpg';
import machshirCase5_2 from '../assets/images/cases/machshir-case5-2.jpg';
import machshirCase5_3 from '../assets/images/cases/machshir-case5-3.jpg';
import machshirCase6_1 from '../assets/images/cases/machshir-case6-1.jpg';
import machshirCase6_2 from '../assets/images/cases/machshir-case6-2.jpg';
import machshirCase6_3 from '../assets/images/cases/machshir-case6-3.jpg';
import machshirCase6_4 from '../assets/images/cases/machshir-case6-4.jpg';
import machshirCase7_1 from '../assets/images/cases/machshir-case7-1.jpg';
import machshirCase7_2 from '../assets/images/cases/machshir-case7-2.jpg';
import machshirCase7_3 from '../assets/images/cases/machshir-case7-3.jpg';

import kifufCase1_1 from '../assets/images/cases/kifuf-case1-1.jpg';
import kifufCase1_2 from '../assets/images/cases/kifuf-case1-2.jpg';
import kifufCase2_1 from '../assets/images/cases/kifuf-case2-1.jpg';
import kifufCase2_2 from '../assets/images/cases/kifuf-case2-2.jpg';

import ripuiCase1_1 from '../assets/images/cases/ripui-case1-1.jpg';
import ripuiCase1_2 from '../assets/images/cases/ripui-case1-2.jpg';
import ripuiCase2_1 from '../assets/images/cases/ripui-case2-1.jpg';
import ripuiCase2_2 from '../assets/images/cases/ripui-case2-2.jpg';
import ripuiCase3_1 from '../assets/images/cases/ripui-case3-1.jpg';
import ripuiCase3_2 from '../assets/images/cases/ripui-case3-2.jpg';
import ripuiCase4_1 from '../assets/images/cases/ripui-case4-1.jpg';
import ripuiCase4_2 from '../assets/images/cases/ripui-case4-2.jpg';
import ripuiCase5_1 from '../assets/images/cases/ripui-case5-1.jpg';
import ripuiCase5_2 from '../assets/images/cases/ripui-case5-2.jpg';
import ripuiCase6_1 from '../assets/images/cases/ripui-case6-1.jpg';
import ripuiCase6_2 from '../assets/images/cases/ripui-case6-2.jpg';
import ripuiCase6_3 from '../assets/images/cases/ripui-case6-3.jpg';
import ripuiCase7_1 from '../assets/images/cases/ripui-case7-1.jpg';
import ripuiCase7_2 from '../assets/images/cases/ripui-case7-2.jpg';
import ripuiCase7_3 from '../assets/images/cases/ripui-case7-3.jpg';

import siumCase1_1 from '../assets/images/cases/sium-case1-1.jpg';
import siumCase1_2 from '../assets/images/cases/sium-case1-2.jpg';
import siumCase1_3 from '../assets/images/cases/sium-case1-3.jpg';
import siumCase1_4 from '../assets/images/cases/sium-case1-4.jpg';
import siumCase2_1 from '../assets/images/cases/sium-case2-1.jpg';
import siumCase2_2 from '../assets/images/cases/sium-case2-2.jpg';
import siumCase2_3 from '../assets/images/cases/sium-case2-3.jpg';
import siumCase3_1 from '../assets/images/cases/sium-case3-1.jpg';
import siumCase3_2 from '../assets/images/cases/sium-case3-2.jpg';
import siumCase4_1 from '../assets/images/cases/sium-case4-1.jpg';
import siumCase4_2 from '../assets/images/cases/sium-case4-2.jpg';
import siumCase4_middle from '../assets/images/cases/sium-case4-middle.jpg';

import morphologiaCase1_1 from '../assets/images/cases/morphologia-case1-1.jpg';
import morphologiaCase1_2 from '../assets/images/cases/morphologia-case1-2.jpg';
import morphologiaCase2_1 from '../assets/images/cases/morphologia-case2-1.jpg';
import morphologiaCase2_2 from '../assets/images/cases/morphologia-case2-2.jpg';
import morphologiaCase3_1 from '../assets/images/cases/morphologia-case3-1.jpg';
import morphologiaCase3_2 from '../assets/images/cases/morphologia-case3-2.png';
import morphologiaCase3_3 from '../assets/images/cases/morphologia-case3-3.jpg';
import morphologiaCase3_4 from '../assets/images/cases/morphologia-case3-4.jpg';
import morphologiaCase3_5 from '../assets/images/cases/morphologia-case3-5.jpg';
import morphologiaCase4_1 from '../assets/images/cases/morphologia-case4-1.jpg';
import morphologiaCase4_2 from '../assets/images/cases/morphologia-case4-2.jpg';

// Add more imports as needed for other cases

export const casesData = {
  'itum-nekev': {
    title: 'איטום נקב',
    description: 'ניקוב הוא חור בדופן השן שיכול להיווצר בטעות ע"י רופא השיניים. קיימת חשיבות לטפל במקרים אלו בהקדם, היות שדרכם עלולים לחדור חיידקים וליצור דלקת. במקרים אלו יש להעריך האם ניתן לטפל ומה סיכויי ההצלחה, ובהתאם לכך לאטום את אותם נקבים עם חומר יעודי וכך להציל את השן.',
    cases: [
      {
        title: 'מקרה 1',
        images: [
          { src: itumCase1_2, alt: 'יתד דנטטוס שחודר לתוך הרקמה התומכת', caption: 'יתד דנטטוס שחודר לתוך הרקמה התומכת' },
          { src: itumCase1_1, alt: 'לאחר ביצוע האיטום עם MTA', caption: 'לאחר ביצוע האיטום עם MTA' },
          { src: itumCase1_3, alt: 'ביקורת לאחר שנתיים וחצי', caption: 'ביקורת לאחר שנתיים וחצי' }
        ]
      },
      {
        title: 'מקרה 2',
        images: [
          { src: itumCase2_1, alt: 'יתד דנטטוס שחודר ויוצר נקב (ע"פ ה-CT)', caption: 'יתד דנטטוס שחודר ויוצר נקב (ע"פ ה-CT)' },
          { src: itumCase2_2, alt: 'איטום הנקב עם MTA וביצוע חידוש טיפול שורש', caption: 'איטום הנקב עם MTA וביצוע חידוש טיפול שורש' }
        ]
      }
    ]
  },
  'guta-perka': {
    title: 'גוטה פרקה שהוצאה מעבר לאפקס',
    description: 'סתימת שורש מורכבת מחומר משכתי וחומר מוצק שנקרא גוטה פרקה. במהלך סתימת השורש, הגוטה פרקה עלולה לחדור מעבר לקצה השורש. במצב שבו נדרש לבצע חידוש טיפול שורש בשן, והגוטה פרקה חדרה מעבר לקצה השורש, רצוי להוציאה. במקרים אלו יש חשיבות לטכניקה ועדינות הטיפול.',
    cases: [
      {
        title: 'מקרה 1',
        images: [
          { src: gutaCase1Middle, alt: 'גוטה פרקה שהוצאה מעבר לאפקס - מקרה 1 אבחנתי', caption: 'אבחנתי' },
          { src: guta4, alt: 'גוטה פרקה שהוצאה מעבר לאפקס - מקרה 1', caption: 'גוטה פרקה שהוצאה מעבר לאפקס' },
          { src: guta3, alt: 'גוטה פרקה שהוצאה מעבר לאפקס - מקרה 1 סופי', caption: 'סופי' }
        ]
      },
      {
        title: 'מקרה 2',
        images: [
          { src: guta5, alt: 'גוטה פרקה שהוצאה מעבר לאפקס - מקרה 2 אבחנתי', caption: 'אבחנתי' },
          { src: guta2, alt: 'גוטה פרקה שהוצאה מעבר לאפקס - מקרה 2', caption: 'גוטה פרקה שהוצאה מעבר לאפקס' },
          { src: guta1, alt: 'גוטה פרקה שהוצאה מעבר לאפקס - מקרה 2 סופי', caption: 'סופי' }
        ]
      },
      {
        title: 'מקרה 3',
        images: [
          { src: guta8, alt: 'גוטה פרקה שהוצאה מעבר לאפקס - מקרה 3 אבחנתי', caption: 'אבחנתי' },
          { src: gutaCase3Middle, alt: 'גוטה פרקה שהוצאה מעבר לאפקס - מקרה 3', caption: 'לאחר הוצאת הגוטה שחדרה לרקמה התומכת' },
          { src: guta7, alt: 'גוטה פרקה שהוצאה מעבר לאפקס - מקרה 3 סופי', caption: 'סופי' }
        ]
      }
    ]
  },
  'havharat-shinayim': {
    title: 'הבהרת שיניים פנימית',
    description: 'שן ששנתה את צבעה בגלל תהליכים שקורים בתוך השן, ניתנת להבהרה ע"י תהליך שנקרא הבהרה פנימית. יש לקחת בחשבון, שלא תמיד ניתן להחזיר את השן לגוון המקורי ועם הזמן עלולה לחול נסיגה בצבע שהושג.',
    cases: [
      {
        title: 'מקרה 1',
        images: [
          { src: havharatCase1_2, alt: 'צילום לפני הטיפול', caption: 'צילום לפני הטיפול' },
          { src: havharatCase2_2, alt: 'צילום בסוף הטיפול', caption: 'צילום בסוף הטיפול' }
        ]
      },
      {
        title: 'מקרה 2',
        images: [
          { src: havharatCase1_1, alt: 'צילום לפני הטיפול', caption: 'צילום לפני הטיפול' },
          { src: havharatCase2_1, alt: 'צילום בסוף הטיפול', caption: 'צילום בסוף הטיפול' }
        ]
      }
    ]
  },
  'hotzaat-machshir-shavor': {
    title: 'הוצאת מכשיר שבור מהתעלה',
    description: 'במהלך טיפול שורש עלול להישבר מכשיר בתעלת השורש. המכשיר השבור יכול לחסום את החדירה לכל אורך התעלה, ובכך למנוע אפשרות של ניקוי נאות של התעלה, ובעקבות כך, התפתחות של דלקת או אי ריפוי של דלקת קיימת. במקרים אלו יש להעריך האם ניתן להוציא או לעקוף את המכשיר השבור, כדי לאפשר ניקוי ואיטום של כל התעלה. במקרים מסוימים ידרש רק מעקב.',
    cases: [
      {
        title: 'מקרה 1',
        images: [
          { src: machshirCase6_1, alt: 'צילום אבחנתי - מקרה 1', caption: 'צילום אבחנתי' },
          { src: machshirCase1_1, alt: 'המכשיר השבור לאחר הוצאתי - מקרה 1', caption: 'המכשיר השבור לאחר הוצאתי' },
          { src: machshirCase1_3, alt: 'צילום סופי - מקרה 1', caption: 'צילום סופי' }
        ]
      },
      {
        title: 'מקרה 2',
        images: [
          { src: machshirCase3_3, alt: 'צילום אבחנתי - מקרה 2', caption: 'צילום אבחנתי' },
          { src: machshirCase3_1, alt: 'צילום סופי - מקרה 2', caption: 'צילום סופי' }
        ]
      },
      {
        title: 'מקרה 3',
        images: [
          { src: machshirCase7_3, alt: 'צילום אבחנתי - מקרה 3', caption: 'צילום אבחנתי' },
          { src: machshirCase1_2, alt: 'המכשיר השבור לאחר ההוצאה - מקרה 3', caption: 'המכשיר השבור לאחר ההוצאה' },
          { src: machshirCase6_4, alt: 'צילום סופי - מקרה 3', caption: 'צילום סופי' }
        ]
      },
      {
        title: 'מקרה 4',
        description: 'בוצע הוצאת המשירים השבורים וחידוש טיפלי שורש',
        images: [
          { src: machshirCase2_2, alt: 'צילום אבחנתי - מקרה 4', caption: 'צילום אבחנתי' },
          { src: machshirCase5_2, alt: 'המכשיר השבור לאחר הוצאתו - מקרה 4', caption: 'המכשיר השבור לאחר הוצאתו' },
          { src: machshirCase2_1, alt: 'צילום לאחר הוצאת המכשיר השבור - מקרה 4', caption: 'צילום לאחר הוצאת המכשיר השבור' }
        ]
      },
      {
        title: 'מקרה 5',
        images: [
          { src: machshirCase4_1, alt: 'צילום אבחנתי - מקרה 5', caption: 'צילום אבחנתי' },
          { src: machshirCase5_3, alt: 'המכשיר השבור לאחר ההוצאה - מקרה 5', caption: 'המכשיר השבור לאחר ההוצאה' },
          { src: machshirCase4_2, alt: 'צילום לאחר הוצאת המכשיר השבור וביצוע טיפול שורש - מקרה 5', caption: 'צילום לאחר הוצאת המכשיר השבור וביצוע טיפול שורש' }
        ]
      },
      {
        title: 'מקרה 6',
        images: [
          { src: machshirCase4_3, alt: 'צילום אבחנתי - מקרה 6', caption: 'צילום אבחנתי' },
          { src: machshirCase6_3, alt: 'צילום אבחנתי מקרוב - מקרה 6', caption: 'צילום אבחנתי מקרוב' },
          { src: machshirCase4_5, alt: 'המכשיר השבור לאחר ההוצאה - מקרה 6', caption: 'המכשיר השבור לאחר ההוצאה' },
          { src: machshirCase7_2, alt: 'צילום לאחר הוצאת המכשיר השבור וביצוע חידוש טיפול שורש - מקרה 6', caption: 'צילום לאחר הוצאת המכשיר השבור וביצוע חידוש טיפול שורש' }
        ]
      },
      {
        title: 'מקרה 7',
        images: [
          { src: machshirCase5_1, alt: 'צילום אבחנתי - מקרה 7', caption: 'צילום אבחנתי' },
          { src: machshirCase7_1, alt: 'המכשיר השבור לאחר הוצאתו - מקרה 7', caption: 'המכשיר השבור לאחר הוצאתו' },
          { src: machshirCase4_4, alt: 'צילום לאחר הוצאת המכשיר השבור - מקרה 7', caption: 'צילום לאחר הוצאת המכשיר השבור' }
        ]
      },
      {
        title: 'מקרה 8',
        images: [
          { src: machshirCase6_2, alt: 'צילום אבחנתי - מקרה 8', caption: 'צילום אבחנתי' },
          { src: machshirCase3_2, alt: 'צילומי מעקב , שנתיים אחרי הוצאת המכשירים השבורים מהתעלות וביצוע חידוש טיפולי שורש - מקרה 8', caption: 'צילומי מעקב , שנתיים אחרי הוצאת המכשירים השבורים מהתעלות וביצוע חידוש טיפולי שורש' }
        ]
      }
    ]
  },
  'tipul-shorash-kifuf': {
    title: 'טיפול שורש בשן עם כיפוף חריג',
    description: 'במקרים בהם שורש השן מאוד מכופף, טיפול השורש דורש תכנון מקדים, מכשור מתאים, וטכניקת טיפול מתאימה.',
    cases: [
      {
        title: 'מקרה 1',
        images: [
          { src: kifufCase2_1, alt: 'צילום אבחנתי - מקרה 1', caption: 'צילום אבחנתי' },
          { src: kifufCase1_2, alt: 'צילום סופי - מקרה 1', caption: 'צילום סופי' }
        ]
      },
      {
        title: 'מקרה 2',
        images: [
          { src: kifufCase2_2, alt: 'צילום אבחנתי - מקרה 2', caption: 'צילום אבחנתי' },
          { src: kifufCase1_1, alt: 'צילום סופי - מקרה 2', caption: 'צילום סופי' }
        ]
      }
    ]
  },
  'refui-negaim': {
    title: 'ריפוי של נגעים סב-שורשיים',
    description: 'בצילום רנטגן ניתן לראות נגע סב-שורשי ע"י אזורים של חוסר עצם סביב השורש. לאחר טיפול שורש, זמן הריפוי והמילוי עם עצם, של אותם חללים, יכול לקחת מספר חודשים עד כשנתיים ולעיתים אף יותר מכך, ולכן במקרים אלו, יש חשיבות לבצע מעקבים.',
    cases: [
      {
        title: 'מקרה 1',
        images: [
          { src: ripuiCase7_3, alt: 'צילום אבחנתי נגע סביב שורש D - מקרה 1', caption: 'צילום אבחנתי נגע סביב שורש D' },
          { src: ripuiCase2_2, alt: 'צילום ביקורת - מקרה 1', caption: 'צילום ביקורת', description: '9 חודשים לאחר מיכן רואים ריפוי של הנגע' }
        ]
      },
      {
        title: 'מקרה 2',
        images: [
          { src: ripuiCase7_2, alt: 'צילום אבחנתי - מקרה 2', caption: 'צילום אבחנתי', description: 'בתעלות M יש סטיה מתוואי התעלות, נקב ונגע סב-שורשי' },
          { src: ripuiCase1_1, alt: 'צילום ביקורת - מקרה 2', caption: 'צילום ביקורת', description: '14 שנים לאחר מיכן רואים ריפוי של הנגע' }
        ]
      },
      {
        title: 'מקרה 3',
        images: [
          { src: ripuiCase3_2, alt: 'צילום אבחנתי - מקרה 3', caption: 'צילום אבחנתי', description: 'נגע סביב שורש M' },
          { src: ripuiCase1_2, alt: 'צילום ביקורת - מקרה 3', caption: 'צילום ביקורת', description: 'שנה ושלושה חודשים לאחר מיכן רואים ריפוי של הנגע' }
        ]
      },
      {
        title: 'מקרה 4',
        images: [
          { src: ripuiCase7_1, alt: 'צילום אבחנתי - מקרה 4', caption: 'צילום אבחנתי (עם גוטה פרקה דרך הסינוס טראקט)', description: 'נגע גדול הכולל את קצות השורשים ואזור המסעף הבין שורשי' },
          { src: ripuiCase6_3, alt: 'צילום ביקורת - מקרה 4', caption: 'צילום ביקורת', description: '3 שנים לאחר מיכן רואים ריפוי של הנגע' }
        ]
      },
      {
        title: 'מקרה 5',
        images: [
          { src: ripuiCase2_1, alt: 'צילום אבחנתי - מקרה 5', caption: 'צילום אבחנתי', description: 'נגע הכולל את קצות השורשים' },
          { src: ripuiCase3_1, alt: 'צילום ביקורת - מקרה 5', caption: 'צילום ביקורת', description: '7 חודשים לאחר מיכן רואים ריפוי של הנגע' }
        ]
      },
      {
        title: 'מקרה 6',
        images: [
          { src: ripuiCase4_2, alt: 'צילום אבחנתי - מקרה 6', caption: 'צילום אבחנתי', description: 'נגע סב-שורשי גדול' },
          { src: ripuiCase6_1, alt: 'צילום בסיום הטיפול - מקרה 6', caption: 'צילום בסיום הטיפול' },
          { src: ripuiCase6_2, alt: 'שנתיים לאחר מיכן - מקרה 6', caption: 'שנתיים לאחר מיכן רואים ריפוי חלקי משמעותי של הנגע' }
        ]
      },
      {
        title: 'מקרה 7',
        images: [
          { src: ripuiCase5_1, alt: 'צילום אבחנתי - מקרה 7', caption: 'צילום אבחנתי', description: 'נגע סב-שורשי גדול' },
          { src: ripuiCase4_1, alt: 'צילום במהלך הטיפול - מקרה 7', caption: 'צילום במהלך הטיפול', description: 'לאחר 3 חודשים עם תרופות חבישה Ca(OH)₂' },
          { src: ripuiCase5_2, alt: 'צילום ביקורת - מקרה 7', caption: 'צילום ביקורת', description: '10 חודשים ו- 15 חודשים מתחילת הטיפול רואים ריפוי של הנע הסב-שורשי' }
        ]
      }
    ]
  },
  'tipul-shorash-shein-lo-siyema': {
    title: 'טיפול שורש בשן שלא סיימה את התפתחותה',
    description: 'בשן קבועה צעירה שלא סיימה את התפתחותה, השורשים עדיין לא מפותחים מספיק ולכן הם קצרים יותר, עם קירות דקים ותעלות רחבות שמסתיימות עם פתח רחב. לפני טיפול בשיניים אלו יש חשיבות לאבחנה של מצב הרקמה הפנימית, היות שאם הרקמה תקינה, ניתן למנוע טיפול שורש ולתת לשן להמשיך להתפתח. במצבים בהם הרקמה הפנימית של השן אינה תקינה, מבצעים טיפול שורש. טיפולי השורש בשיניים אלו מבוצעים בשיטות שונות, תלוי בשלב ההתפתחות שבו השורשים נמצאים.',
    cases: [
      {
        title: 'מקרה 1',
        images: [
          { src: siumCase1_1, alt: 'צילום אבחנתי - מקרה 1', caption: 'צילום אבחנתי' },
          { src: siumCase1_2, alt: 'אחרי הוצאת סתימת השורש - מקרה 1', caption: 'אחרי הוצאת סתימת השורש' },
          { src: siumCase1_3, alt: 'בסיום הטיפול - מקרה 1', caption: 'בסיום הטיפול' },
          { src: siumCase1_4, alt: 'צילום ביקורת - מקרה 1', caption: 'צילום ביקורת', description: 'אחרי חצי שנה' }
        ]
      },
      {
        title: 'מקרה 2',
        images: [
          { src: siumCase2_3, alt: 'צילום אבחנתי - מקרה 2', caption: 'צילום אבחנתי' },
          { src: siumCase2_2, alt: 'במהלך טיפול השורש - מקרה 2', caption: 'במהלך טיפול השורש' },
          { src: siumCase2_1, alt: 'לאחר חודש וחצי - מקרה 2', caption: 'לאחר חודש וחצי', description: 'ניתן לראות ריפוי של הנגע הסב-חודי' }
        ]
      },
      {
        title: 'מקרה 3',
        images: [
          { src: siumCase3_1, alt: 'אבחנתי - מקרה 3', caption: 'אבחנתי' },
          { src: siumCase3_2, alt: 'סופי - מקרה 3', caption: 'סופי' }
        ]
      },
      {
        title: 'מקרה 4',
        images: [
          { src: siumCase4_1, alt: 'אבחנתי - מקרה 4', caption: 'אבחנתי' },
          { src: siumCase4_middle, alt: 'במהלך טיפול השורש - מקרה 4', caption: 'במהלך טיפול השורש' },
          { src: siumCase4_2, alt: 'סופי - מקרה 4', caption: 'סופי' }
        ]
      }
    ]
  },
  'tipul-shorash-morphologia': {
    title: 'טיפול שורש בשן עם מורפולוגיה חריגה',
    description: 'במקרים בהם לשן יש צורה חריגה, נדרש שימוש בציוד ומכשור מיוחדים, וזאת לאחר תכנון הטיפול בעזרת צילומים תלת-ממדיים (CBCT) שנותנים מידע מדויק על האנטומיה של השן.',
    cases: [
      {
        title: 'מקרה 1',
        images: [
          { src: morphologiaCase1_1, alt: 'צילום אבחנתי - מקרה 1', caption: 'צילום אבחנתי' },
          { src: morphologiaCase1_2, alt: 'צילום סופי - מקרה 1', caption: 'צילום סופי' }
        ]
      },
      {
        title: 'מקרה 2',
        images: [
          { src: morphologiaCase2_1, alt: 'צילום אבחנתי - מקרה 2', caption: 'צילום אבחנתי' },
          { src: morphologiaCase2_2, alt: 'צילום סופי - מקרה 2', caption: 'צילום סופי' }
        ]
      },
      {
        title: 'מקרה 3',
        images: [
          { src: morphologiaCase3_1, alt: 'צילום אבחנתי - מקרה 3', caption: 'צילום אבחנתי' },
          { src: morphologiaCase3_2, alt: 'חתך קורונלי ב-CBCT - מקרה 3', caption: 'חתך קורונלי ב-CBCT' },
          { src: morphologiaCase3_3, alt: 'בסיום הטיפול - מקרה 3', caption: 'בסיום הטיפול' },
          { src: morphologiaCase3_4, alt: 'צילום ביקורת לאחר 4 חודשים - מקרה 3', caption: 'צילום ביקורת', description: 'לאחר 4 חודשים' },
          { src: morphologiaCase3_5, alt: 'צילום ביקורת לאחר שנה - מקרה 3', caption: 'צילום ביקורת', description: 'לאחר שנה רואים ריפוי של הנגע' }
        ]
      },
      {
        title: 'מקרה 4',
        images: [
          { src: morphologiaCase4_1, alt: 'צילום אבחנתי - מקרה 4', caption: 'צילום אבחנתי' },
          { src: morphologiaCase4_2, alt: 'צילום סופי - מקרה 4', caption: 'צילום סופי' }
        ]
      }
    ]
  }
  // Add more cases as needed
};

